<template>
    <div class="innerMainContent">
        <div class="row">
            <div class="col-md-6 col-xs-12 matchHeight">
                <div class="innerBox" v-if="!showLoader">
                    <div class="eventInfoWrapper">
                        <div class="imgWrap" v-if="$store.state.event.gallery[0]">
                            <img :src="('//' + $store.state.app.domain + '/kioskImages/' + $store.state.event.gallery[0])" alt="">
                        </div>
                        <div class="infoWrap">
                            <h1>{{ $store.state.event.name }}</h1>
                            <div class="eventType">{{ $store.state.event.type.title }}</div>
                            <div class="eventDate">
                                <svg><use xlink:href="#i_calender"></use></svg>
                                <span>{{ $store.state.event.dateStr }}</span>
                            </div>
                            <div class="eventTimeLeft">{{ $t('daysUntilEvent',{days:(moment.unix($store.state.event.date-10800).diff(moment(),'days'))}) }}</div>
                            <!--<div class="eventTimeLeft">
                                <CountDownTimer :date="$store.state.event.date"/>
                            </div>-->
                        </div>
                    </div>
                </div>
                <div class="innerBoxLoader" v-if="showLoader">
                    <rotate-loader style="opacity: .6" :color="'#132C43'"></rotate-loader>
                </div>
            </div>
            <EventGuestsStatistics :eventData="$store.state.event" v-if="$store.state.event.id" v-on:initiated="setGuests"></EventGuestsStatistics>
        </div>
        <div class="row">
            <BannerView v-for="banner of $store.state.app.banners.map((a) => [Math.random(),a]).sort((a,b) => a[0]-b[0]).map((a) => a[1]).slice(0,2)" :banner="banner" :key="'banner_' + banner.id"></BannerView>
        </div>
        <div class="row actionBoxes" v-if="!showLoader">
            <div class="matchHeight col-md-4" v-if="$store.state.event.hasSms">
                <router-link :to="'/sms/' + $store.state.event.id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_template"></use></svg>
							</span>
                    <span class="linkText">
								<div class="linkTxtNum">{{ getSmsCount('sent') }}</div>
								<div class="linkTxtHeader">{{ $t('smsSent') }}</div>
							</span>
                    <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                </router-link>
            </div>
            <div class="matchHeight col-md-4">
                <router-link :to="'/guests/' + $store.state.event.id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_users"><use xlink:href="#i_users"></use></svg>
							</span>
                    <span class="linkText">
								<div class="linkTxtNum">{{ guests.length }}</div>
								<div class="linkTxtHeader">{{ $t('guestsInSystem') }}</div>
							</span>
                    <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                </router-link>
            </div>
            <div class="matchHeight col-md-4">
                <router-link :to="'/seating/' + $store.state.event.id" class="innerBox">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_seating"></use></svg>
							</span>
                    <span class="linkText">
								<div class="linkTxtNum">{{ getTakenSeats() }}</div>
								<div class="linkTxtHeader">{{ $t('seatedGuests') }}</div>
							</span>
                    <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                </router-link>
            </div>
            <div class="matchHeight col-md-4">
                <router-link to="/screen" class="innerBox">
							<span class="svgWrap">
								<svg class="i_template"><use xlink:href="#i_template"></use></svg>
							</span>
                    <span class="linkText">
								<div class="linkTxtNum">{{ eventDesignStat() }}%</div>
								<div class="linkTxtHeader">{{ $t('fromEventDesign') }}</div>
							</span>
                    <svg class="i_linkArr"><use xlink:href="#i_linkArr"></use></svg>
                </router-link>
            </div>
        </div>
        <div class="row text-center" style="padding-top: 50px " v-if="showLoader">
            <rotate-loader style="opacity: .6" :color="'#132C43'"></rotate-loader>
        </div>
    </div>
</template>

<script>
    import RotateLoader from 'vue-spinner/src/RotateLoader.vue'
    import BannerView from '../Banners/BannerView'
    import EventGuestsStatistics from '../Events/EventGuestsStatistics'
    import CountDownTimer from "../Common/CountDownTimer";

    export default {
        name: "ClientDashboard",
        components:{
            CountDownTimer,
            RotateLoader,
            BannerView,
            EventGuestsStatistics
        },
        data(){
            return{
                guests:[],
                showLoader:false
            }
        },
        methods:{
            setGuests(_){
                this.guests = _;
            },
            getTakenSeats(){
                return this.guests
                    .filter((_)=>{ if(_.tableID > 0) return true; })
                    .map(a => a.tableID).length;
            },
            eventDesignStat(){
                return 60;
            },
            getSmsCount(type = 'sent'){
                return 5;
            }
        },
        mounted(){
            setTimeout(function(){ $(".matchHeight").matchHeight(); },500)
        }
    }
</script>
<style scoped>
    .innerBox{
        padding:0
    }


    .pieWrapper .pieInnerWrapper{
        width:50%;
        float: right;
    }

    .pieWrapper #pie-svg{
        width:50%;
        float: right;
    }

    [data-pie-id] > *:nth-child(7n+1), [data-bar-id] > *:nth-child(7n+1), [data-line-id] > *:nth-child(7n+1) {
        color: #293b5a; }
    [data-pie-id] > *:nth-child(7n+2), [data-bar-id] > *:nth-child(7n+2), [data-line-id] > *:nth-child(7n+2) {
        color: #465a7f; }
    [data-pie-id] > *:nth-child(7n+3), [data-bar-id] > *:nth-child(7n+3), [data-line-id] > *:nth-child(7n+3) {
        color: #5e769f; }
    [data-pie-id] > *:nth-child(7n+4), [data-bar-id] > *:nth-child(7n+4), [data-line-id] > *:nth-child(7n+4) {
        color: #7792bf; }



    #pie, #donut, #bar {
        max-height: 450px; }


    svg {
        width: 100%;
        height: auto;
    }


    ul[data-pie-id] {
        list-style: none;
    }
    .pieWrapper ul li{
        font-size:1.118rem;
    }
    .pieWrapper ul li + li{
        margin-top:10px;
    }
    .pieWrapper ul li span{
        color:#2e2e2e;
    }
    .pieWrapper ul li span span{
        font-weight: 700;
        font-style: italic;
    }
    .pieWrapper ul li:before{
        content: "";
        width:17px;
        height:17px;
        border-radius: 50%;
        display:inline-block;
        margin-top:2px;
        margin-left:15px;

    }
    .pieWrapper .pieInnerWrapper{
        padding:0 30px;
    }
    .pieWrapper .pieInnerWrapper h2{

        margin:20px 0px;

    }
    .pieWrapper ul li.notResponded:before{background:#5e769f;}
    .pieWrapper ul li.respondedPositive:before{background:#465a7f;}
    .pieWrapper ul li.respondedMaybe:before{background:#7792bf;}
    .pieWrapper ul li.respondedNegative:before{background:#293b5a;}

    .pieWrapper ul li.notResponded span .status{color:#5e769f;}
    .pieWrapper ul li.respondedPositive span .status{color:#465a7f;}
    .pieWrapper ul li.respondedMaybe span .status{color:#7792bf;}
    .pieWrapper ul li.respondedNegative span .status{color:#293b5a;}
    .innerMainContent {
        padding: 55px 45px;
        float: right;
        width: 100%;
    }
    .eventInfoWrapper {
        padding: 20px;
        float: right;
        width: 100%;
    }

    .imgWrap{
        width: 50%;
        float: right;
    }
    .imgWrap img{
        width:100%;
    }

    .actionBoxes .innerBox{
        width:100%;
        display:block;
        padding: 30px;
        background: #fff;
        transition: background .25s ease-in-out;
        -moz-transition: background .25s ease-in-out;
        -webkit-transition: background .25s ease-in-out;

    }
    .actionBoxes .innerBox:hover,
    .actionBoxes .innerBox:focus{
        text-decoration: none;
        transition: background .25s ease-in-out;
        -moz-transition: background .25s ease-in-out;
        -webkit-transition: background .25s ease-in-out;
        background: -moz-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41,59,90,1)), color-stop(100%, rgba(123,150,196,1))); /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* ie10+ */
        background: linear-gradient(90deg, rgba(41,59,90,1) 0%, rgba(123,150,196,1) 100%); /* w3c */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4',GradientType=1 ); /* ie6-9 */
    }
    .actionBoxes .innerBox + .innerBox{
        margin-top:45px;
    }
    .actionBoxes .innerBox .svgWrap{
        display:block;
        margin: 0 auto;
        vertical-align:middle;
        width:83px;
        height:83px;
        border-radius:50%;
        border:1px solid #80ebdf;
        background: #fff;
        text-align: center;
        margin-bottom:20px;
    }
    .actionBoxes .innerBox .svgWrap .i_users{
        width:39px;
        height:29px;
        fill:#293b5a;
        margin-top: 24px;
    }
    .actionBoxes .innerBox .svgWrap .i_template{
        width:19px;
        height:30px;
        fill:#293b5a;
        margin-top: 25px;
    }
    .actionBoxes .innerBox .linkText{
        text-align: center;
    }
    .actionBoxes .innerBox .linkText .linkTxtNum{
        color:#99aed1;
        font-size:2.412rem;
        font-weight:400;
    }
    .actionBoxes .innerBox .linkText .linkTxtHeader{
        color:#293b5a;
        font-size: 1.059rem;
        font-weight:700;
    }
    .actionBoxes .innerBox:hover .linkTxtNum,
    .actionBoxes .innerBox:focus .linkTxtNum,
    .actionBoxes .innerBox:hover .linkTxtHeader,
    .actionBoxes .innerBox:focus .linkTxtHeader{
        color:#fff;
    }
    .actionBoxes .innerBox .i_linkArr{
        display: block;
        vertical-align: middle;
        fill: #7b96c4;
        width: 38px;
        height: 38px;
        margin: 20px auto 0;
    }
    .actionBoxes .innerBox:hover .i_linkArr,
    .actionBoxes .innerBox:focus .i_linkArr{
        fill:#fff;
    }
    .matchHeight .innerBox{
        height:100%;
    }
    .actionBoxes{
        margin-top:30px;
    }
    .infoWrap{
        width:50%;
        float: right;
        text-align: center;
    }
    .infoWrap h1{
        color:#293b5a;
        font-size: 2.353rem;
        font-weight: 700;
    }
    .eventType{
        color:#87a0c9;
        font-weight: 700;
        font-style: italic;
        font-size: 1.529rem;
    }
    .eventDate{
        display: inline-block;
        padding: 15px 20px;
        position: relative;
        margin: 20px 0;
    }
    .eventDate:before,
    .eventDate:after{
        content: "";
        height:1px;
        width: 100%;
        background: #55e4d4;
        position: absolute;
        right:0;
    }
    .eventDate:before{
        bottom:100%;
    }
    .eventDate:after{
        top:100%;
    }
    .eventDate svg{
        width:29px;
        height:29px;
        fill:#293b5a;
        display: inline-block;
        vertical-align: middle;
        margin-left:10px;
    }
    .eventDate span{
        color:#293b5a;
        font-size: 1.353rem;
        display: inline-block;
        vertical-align: middle;

    }
    .eventTimeLeft{
        color:#eb001c;
        font-size: 1.176rem;
    }

</style>
